import { render, staticRenderFns } from "./StatisticPage.vue?vue&type=template&id=05d2b216&scoped=true&"
import script from "./StatisticPage.vue?vue&type=script&lang=js&"
export * from "./StatisticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2b216",
  null
  
)

export default component.exports